import React from 'react';
import { connect } from 'react-redux';
import { DirectMessageAction } from 'redux/actions';
import noImage from 'assets/img/users/no-image.jpg';
import {timeAgo} from '../../hooks';
import { IoCheckmark,IoCheckmarkDone   } from "react-icons/io5";
import {Form, Button} from 'reactstrap';
import { MdError } from "react-icons/md";
import Skeleton from '@mui/material/Skeleton';
import io from 'socket.io-client';
import {getToken,getLoginData} from 'hooks/storage';



const DirectMessages = (props)=> {


  const token = getToken();
  const loginData = getLoginData();
  let [socket, setSocket] = React.useState(null);
  React.useEffect(() => {
  const socket = loginData ?io.connect((process.env.REACT_APP_SOCKET_URL)?process.env.REACT_APP_SOCKET_URL:'http://localhost:3000',{
    extraHeaders: {
      Authorization: `Bearer ${token}`,
      username:JSON.parse(loginData).username,
      usertype:'ADMIN'
    }
  }):null;
  setSocket(socket)
},[]);

  const limit = 10;
  const isFirstRender = React.useRef(true);
  let [messageSent, setMessageSent] = React.useState(0);
  let [page, setPage] = React.useState(0);
  const msgRef = React.useRef(null);
  const chatContainerRef = React.useRef(null);
  let [messages, setMessages] = React.useState([]);
  let [channel, setCannel] = React.useState(null);
  let [showTypingMsg, setShowTypingMsg] = React.useState('');
  const [isFocused, setIsFocused] = React.useState(false);
  let [userStatus, setUserStatus] = React.useState('');
  
  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };



  React.useEffect(() => {
   
    if (
      isFirstRender.current ||
      props.totalCount > messages.length ||
      props.totalPage > page
    ) {
      props.fetchDirectMessage({
        user_id: props.userId,
        page: page,
        limit: limit,
      });
      isFirstRender.current = false;
    }
  }, [page]);

  React.useEffect(() => {

    if(!channel && props.room && props.room.channel){
      setCannel(props.room.channel);
    }
    if (props.messageList) {
      //setMessages(current => [...current, ...props.messageList]);
      setMessages(current => [...props.messageList, ...current]);
    }
  }, [props.messageList]);


  React.useEffect(() => {
    if(channel && isFocused){
      socket.emit('typing', props.loginData.username + ' is typing...', channel);
    }else if(channel) {
      socket.emit('typing', '', channel);
    }
  },[isFocused]);



  React.useEffect(() => {
    console.log('data-------------------------------------', channel)
    if(channel && socket){
      const data = { channel: channel, user: props.loginData.username, token: `Bearer ${token}`,usertype:'ADMIN' };
      
      socket.emit('join', JSON.stringify(data));

      socket.on('typing', function (data) {
        const typeingJson = JSON.parse(data);
        setShowTypingMsg(typeingJson.message);
        setTimeout(()=>{
          setShowTypingMsg('');
        },1000);
        setUserStatus('');
      });

      socket.on('user_left', function (data) {
        setUserStatus(data.user + " has left");
      });
      socket.on('join', function (data) {
        setUserStatus(data.user + " has joined");
      });

      socket.on('TEXT', function (data) {
        const datajson = JSON.parse(data);
        setMessages(current => [
          ...current,
          ...[
            {
              created_at: datajson.message.created_at,
              message: datajson.message.message,
              avatar: datajson.message.sender.avatar,
              sender_id: datajson.message.sender.id,
            },
          ],
        ]);
      });
    }
  },[channel]);

  

  

  const onKeyDownHandler = e => {
    
    if (e.keyCode === 13) {
      e.preventDefault();
      sendMessage();
    }
  };

  const handleSubmit = (e) => {
    sendMessage();
  };

  const sendMessage = () => {
    if (msgRef.current.value) {
      const message = msgRef.current.value;
      const timestamp = Date.now();
      const payload = {
        user_id: props.userId,
        message: message,
        timestamp: timestamp,
      };
      props.sendDirectMessage(payload);
      setMessageSent(1);
      // setMessages(current => [
      //   ...current,
      //   ...[
      //     {
      //       created_at: new Date(),
      //       message: message,
      //       avatar: props.loginData.avatar,
      //       sender_id: props.loginData.id,
      //       pending: 1,
      //       status: 'unread',
      //       timestamp: timestamp, // to mark message as sent
      //     },
      //   ],
      // ]);
      msgRef.current.value = '';
    }
  };

  React.useEffect(() => {
    if (chatContainerRef.current) {
      if (page === 0 || messageSent === 1)
        chatContainerRef.current.scrollTop =
          chatContainerRef.current.scrollHeight;
      else chatContainerRef.current.scrollTop = 100;

      //
    }
  }, [messages]);

  React.useEffect(() => {
    if (props.savedMessageTimestamp) {
      // const updatedMessages = messages.map(item => {
      //   if (item.timestamp === props.savedMessageTimestamp.timestamp) {
      //     return { ...item, pending: props.savedMessageTimestamp.pending };
      //   }
      //   return item;
      // });
      // setMessages(updatedMessages);
      if(socket){
      socket.emit('send_message', JSON.stringify(
        {to:props.savedMessageTimestamp.to, 
          user:props.savedMessageTimestamp.user, 
          socket_id:props.savedMessageTimestamp.socket_id,
          message:props.savedMessageTimestamp.message
        }));
      }

    }
  }, [props.savedMessageTimestamp]);

  const handleImgError = e => {
    e.target.src = noImage;
    console.log('e', e);
  };

  const handleScroll = e => {
    const top = e.target.scrollTop; // This gives you the distance from the top
    if (top === 0) {
      setPage(page + 1);
      setMessageSent(0);
    }
  };
  return (
    <div className="container">
      <div className="row clearfix">
        <div className="col-lg-12">
          <div className="card chat-app">
            <div className="chat">
              <div className="chat-header clearfix">
                <div className="row">
                  <div className="col-lg-6" style={{ marginBottom: 0 }}>
                    <img
                      src={
                        props.user && props.user.avatar
                          ? props.user.avatar
                          : noImage
                      }
                      onError={e => handleImgError(e)}
                      alt="avatar"
                    />

                    <div className="chat-about">
                      <h6 className="m-b-0">
                        {props.user ? props.user.name : ''}
                      </h6>
                      <small>
                        Last seen:{' '}
                        {props.user && props.user.last_interacted
                          ? timeAgo(props.user.last_interacted)
                          : ''}
                      </small>
                    </div>
                  </div>
                  <div className="col-lg-6 hidden-sm text-right"></div>
                </div>
              </div>
              <div
                className="chat-history"
                ref={chatContainerRef}
                onScroll={handleScroll}
              >
                <ul className="m-b-0">
                  {props.isLoading && messages.length === 0 ? (
                    [1, 2, 3].map(() => (
                      <li className="clearfix">
                        <div style={{ display: 'grid' }}>
                          <div>
                            <Skeleton
                              className="message-data-time float-right"
                              animation="wave"
                              variant="rectangular"
                              width={40}
                              height={40}
                              style={{ marginRight: 5, borderRadius: '40px' }}
                            />
                            <Skeleton
                              className="float-right"
                              variant="rectangular"
                              width={100}
                              height={20}
                              style={{
                                marginTop: 12,
                                borderRadius: 5,
                                marginRight: 10,
                              }}
                            />
                          </div>
                          <div>
                            <Skeleton
                              className="message other-message float-right"
                              variant="rectangular"
                              width={200}
                              height={40}
                              style={{ marginTop: 5, borderRadius: 5 }}
                            />
                          </div>
                        </div>
                      </li>
                    ))
                  ) : messages.length > 0 ? (
                    messages.map(element => {
                      const rightClass =
                        element.sender_id === props.loginData.id
                          ? 'text-right'
                          : '';
                      const msgRightClass =
                        element.sender_id === props.loginData.id
                          ? 'float-right'
                          : '';
                      return (
                        <li className="clearfix">
                          <div className={`message-data ${rightClass}`}>
                            {element.sender_id === props.loginData.id ? (
                              <>
                                <span className="message-data-time">
                                  {timeAgo(element.created_at)}
                                </span>
                                <img
                                  src={
                                    element.avatar ? element.avatar : noImage
                                  }
                                  onError={e => handleImgError(e)}
                                  alt="avatar"
                                />
                              </>
                            ) : (
                              <>
                                <img
                                  src={
                                    element.avatar ? element.avatar : noImage
                                  }
                                  onError={e => handleImgError(e)}
                                  alt="avatar"
                                />
                                <span className="message-data-time">
                                  {timeAgo(element.created_at)}
                                </span>
                              </>
                            )}
                          </div>
                          <div
                            className={`message other-message ${msgRightClass}`}
                          >
                            {element.message}
                            <div className="msg-read-status">
                              {element.pending === 1 ? (
                                <IoCheckmark />
                              ) : element.pending === 2 ? (
                                <MdError className="msg-error" />
                              ) : (
                                <IoCheckmarkDone
                                  className={
                                    element.status === 'read'
                                      ? 'msg-read'
                                      : 'msg-unread'
                                  }
                                />
                              )}
                            </div>
                          </div>
                        </li>
                      );
                    })
                  ) : (
                    <li className="text-center">
                      There is no conversation yet.
                    </li>
                  )}
                </ul>
              </div>
              <div className="chat-message clearfix">
                <Form onKeyDown={onKeyDownHandler}>
                  <div className="typing-text">
                    {showTypingMsg ? (
                      <div className="typing">{showTypingMsg}</div>
                    )
                    :userStatus?<div className='user-status'>{userStatus}</div>:''
                  }
                  </div>

                  
                  

                  <div className="input-group mb-0">
                    

                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter your message here..."
                      ref={msgRef}
                      onFocus={handleFocus}
                      onBlur={handleBlur}
                    />
                    <Button
                      size="sm"
                      color="primary"
                      className="border-0 send-btn"
                      onClick={handleSubmit}
                    >
                      Send
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
    user: (state.user && state.user.userProfile && state.user.userProfile.userdetails) ? state.user.userProfile.userdetails : null,
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    messageList: (state.directMessage && state.directMessage.directMessageList && state.directMessage.directMessageList.chat_messages) ? 
    state.directMessage.directMessageList.chat_messages : null,

    room: (state.directMessage && state.directMessage.directMessageList && state.directMessage.directMessageList.room) ? 
    state.directMessage.directMessageList.room : null,

    totalPage:(state.directMessage && state.directMessage.directMessageList && state.directMessage.directMessageList.total_page) ? 
    state.directMessage.directMessageList.total_page : null,

    totalCount:(state.directMessage && state.directMessage.directMessageList && state.directMessage.directMessageList.total_count) ? 
    state.directMessage.directMessageList.total_count : null,

    savedMessageTimestamp: (state.directMessage && state.directMessage.directMessageSaved && state.directMessage.directMessageSaved.data) ? 
    state.directMessage.directMessageSaved.data : null,
});
const mapDispatchToProps = (dispatch) => ({
  fetchDirectMessage: (payload) => dispatch(DirectMessageAction.fetchDirectMessage(payload)),
  sendDirectMessage: (payload) => dispatch(DirectMessageAction.sendDirectMessage(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(DirectMessages);

